<template>
  <div>

    <b-modal ref="showalert-modal" id="showalert-modal" size="md" centered hide-footer>
      <template slot="modal-header">
        <h4 class="modal-title">Mededeling</h4>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <div class="row mt-2 mb-4">
            <div class="col-md-13">
              Beste relatie,<br />
              <br />
              In verband met onderhoudswerkzaamheden van 17 t/m 19 juli kan de werking van de configurator hinder ondervinden.<br />
              Excuses voor het ongemak.<br />
              <br />
              Team Oldevuuren
            </div>
          </div>
          <div class="row justify-content-center mt-2">
            <div class="col-md-13">
              <button
                class="btn btn-oldevuuren w-100 btn-round"
                @click="onClose"
              >
                Sluiten
              </button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
  export default {
    methods: {
      showModal() {
        this.$refs['showalert-modal'].show()
      },
      onClose() {
        // Close the modal
        this.$refs['showalert-modal'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
